import {
    booking,
    crm,
    footer,
    navbar,
    rkeeper,
    settings,
} from '@config/navigation/items';
import { IAcl, INavMenu } from '@types';

const factories = { navbar, rkeeper, booking, crm, settings, footer };

export const navigationItems = (rules: IAcl | undefined): INavMenu => {
    const result = {} as INavMenu;
    (Object.keys(factories) as Array<keyof INavMenu>).forEach(key => {
        result[key] = factories[key](rules);
    });
    return result;
};

export default navigationItems;
